import React, { useContext } from 'react';
import { dayjs } from 'helpers/dayjs';
import { AppContext } from 'context/app-context';
import { ReactComponent as Logo } from 'assets/images/logo.svg';
import {
  classnames,
  isRestrictedVault,
  isLockedVault,
  isOwner,
} from 'helpers/utils';
import { KeyIcon, QrTinyIcon } from 'assets/icons';
import { isEmpty } from 'lodash';
import { Button, ButtonStyle } from 'common/button';
import { VaultStorage } from '../vault-storage';
import styles from './vault-card-row.module.scss';

type VaultCardRowProps = {
  vault: VaultType;
  showVaultStatusLabel: Function;
  notifyClickCard: (id: number, keyEvent?: boolean) => () => void;
  notifyClickQrIcon: (id: number) => void;
};

const VaultCardRow: React.FC<VaultCardRowProps> = ({
  vault,
  showVaultStatusLabel,
  notifyClickCard,
  notifyClickQrIcon,
}) => {
  const { state } = useContext(AppContext);
  const { user } = state.data;

  const showDefaultPicture = () => (
    <div className={styles.defaultpicture}>
      <Logo className={styles.logo} />
    </div>
  );

  const showCardRow = () => (
    <button
      type="button"
      className={styles.cardRow}
      onClick={notifyClickCard(vault.id)}
      onKeyDown={notifyClickCard(vault.id, true)}
    >
      <div className={styles.pictureAndName}>
        <div className={styles.pictureRounded}>
          {vault.coverThumbnailUrl ? (
            <img
              src={vault.coverThumbnailUrl}
              className={classnames(styles.picture, {
                [styles.greyImage]:
                  isRestrictedVault(vault) || isLockedVault(vault),
              })}
              alt="logo"
            />
          ) : (
            showDefaultPicture()
          )}
        </div>
        <div className="text__body__semi__bold__medium__gray800">
          {vault.title}
        </div>
        {!isEmpty(vault.qrCodes) && (
          <Button
            className={styles.qrIconButton}
            buttonStyle={ButtonStyle.PrimaryGhost}
            onClick={(event) => {
              event.stopPropagation();
              notifyClickQrIcon(vault.id);
            }}
          >
            <QrTinyIcon className={styles.qrIcon} />
          </Button>
        )}
      </div>

      <div
        className={classnames(
          styles.lastUpdate,
          'text__body__regular__medium__gray700',
        )}
      >
        {dayjs(vault.lastUpdate).fromNow()}
      </div>
      <div
        className={classnames(
          'text__body__regular__medium__gray700',
          styles.vaultOwner,
        )}
      >
        {isOwner(user, vault) ? (
          <>
            <KeyIcon className={styles.ownerIcon} />
            <span> You </span>
          </>
        ) : (
          vault.owner.name
        )}
      </div>

      <VaultStorage vault={vault} className={styles.storage} />

      <div
        className={classnames(
          styles.status,
          'text__body__regular__medium__gray700',
        )}
      >
        {showVaultStatusLabel(vault, styles.statusLabelPosition)}
      </div>
    </button>
  );

  return showCardRow();
};

export { VaultCardRow };
